var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3371_11795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 13.75C22.075 13.75 23.7375 12.075 23.7375 10C23.7375 7.925 22.075 6.25 20 6.25C17.925 6.25 16.25 7.925 16.25 10C16.25 12.075 17.925 13.75 20 13.75ZM10 13.75C12.075 13.75 13.7375 12.075 13.7375 10C13.7375 7.925 12.075 6.25 10 6.25C7.925 6.25 6.25 7.925 6.25 10C6.25 12.075 7.925 13.75 10 13.75ZM10 16.25C7.0875 16.25 1.25 17.7125 1.25 20.625V23.75H18.75V20.625C18.75 17.7125 12.9125 16.25 10 16.25ZM20 16.25C19.6375 16.25 19.225 16.275 18.7875 16.3125C20.2375 17.3625 21.25 18.775 21.25 20.625V23.75H28.75V20.625C28.75 17.7125 22.9125 16.25 20 16.25Z",
    fill: "#5177FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3371_11795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group_icon.c8a3dd1b7cd3446eb615ad7a72acefe4.svg";
export { ForwardRef as ReactComponent };